import React from 'react';
import { Card, CardContent, CardHeader, Skeleton, Stack } from '@mui/material';

interface SkeletonCardProps {
  title?: boolean;
  rows?: number;
  height?: number;
}

function SkeletonCard({ title, rows = 4, height }: SkeletonCardProps) {
  return (
    <Card>
      {title && (
        <CardHeader
          title={<Skeleton variant="text" width={150} height={28} />}
          action={<Skeleton variant="rectangular" width={80} height={32} />}
        />
      )}
      <CardContent>
        {height ? (
          <Skeleton variant="rectangular" height={height} />
        ) : (
          <Stack spacing={2}>
            {Array.from({ length: rows }).map((_, i) => (
              <Stack key={i} direction="row" justifyContent="space-between">
                <Skeleton variant="text" width={100} height={24} />
                <Skeleton variant="text" width={150} height={24} />
              </Stack>
            ))}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}

export default SkeletonCard;
